// Temporarily hide calendar/accounts trade import UI.
// The filter-header Import button and /add-trade are gated by admin role instead.
const SHOW_TRADE_IMPORT = false;

export default SHOW_TRADE_IMPORT;
